import { render, staticRenderFns } from "./cuslicencelinfonoteTask.vue?vue&type=template&id=bd2b3854&scoped=true"
import script from "./cuslicencelinfonoteTask.vue?vue&type=script&lang=js"
export * from "./cuslicencelinfonoteTask.vue?vue&type=script&lang=js"
import style0 from "./cuslicencelinfonoteTask.vue?vue&type=style&index=0&id=bd2b3854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2b3854",
  null
  
)

export default component.exports